module.exports = __webpack_public_path__ + "static/media/29DUNON7.f80976b8.jpg";